var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.36 0.655999V12H4.552C6.664 12 8.072 10.688 8.072 8.864C8.072 7.52 7.24 6.48 6.04 6.16C7.016 5.808 7.72 4.912 7.72 3.712C7.72 1.936 6.44 0.655999 4.264 0.655999H0.36ZM2.264 5.456V2.288H3.96C5.128 2.288 5.8 2.912 5.8 3.872C5.8 4.816 5.128 5.456 4.008 5.456H2.264ZM2.264 10.368V7.072H4.28C5.464 7.072 6.12 7.76 6.12 8.736C6.12 9.744 5.368 10.368 4.216 10.368H2.264Z",
    fill: "#ED984F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.c32484df.svg";
export { ForwardRef as ReactComponent };